import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import Typography from '../layout/Typography';

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
        maxWidth: 1000,
        marginLeft: 'auto',
        marginRight: 'auto'
    }),
    center: {
        textAlign: 'center'
    },
    monospace: {
        fontFamily: 'monospace'
    },
    lButton: {
        position: 'absolute',
        top: 5,
        left: 5
    }
});

class Display extends Component {
    render() {
        const {
            showChords,
            setShowChords,
            setHideChords,
            classes,
            item,
            includeNextSong,
            nextAction
        } = this.props;

        return (
            <div>
                <div className={classes.lButton}>
                    {showChords &&
                        setHideChords && (
                            <Button size="small" onClick={setHideChords}>
                                Hide Chords
                            </Button>
                        )}
                    {!showChords &&
                        setShowChords && (
                            <Button size="small" onClick={setShowChords}>
                                Show Chords
                            </Button>
                        )}
                </div>

                <Paper className={classes.root} elevation={4}>
                    <Typography
                        variant="headline"
                        component="h1"
                        className="center"
                        style={{ fontSize: '2.5em' }}
                    >
                        {item.title}

                        {showChords &&
                            includeNextSong && (
                                <Button onClick={nextAction}>Next song</Button>
                            )}
                    </Typography>

                    {showChords && (
                        <Typography
                            component="pre"
                            className="monospace"
                            id="songWithChords"
                            fitText={true}
                        >
                            {item.chords}
                        </Typography>
                    )}
                    {!showChords && (
                        <Typography
                            component="div"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {item.lyrics}
                        </Typography>
                    )}
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles)(Display);



// WEBPACK FOOTER //
// ./src/components/song/Display.js